export function expandCollaboratorInitials(description: string, userNames: Record<string, string>) {
  const initials = Object.keys(userNames)
    .filter(initial => initial.length >= 2 && userNames[initial] && userNames[initial] !== initial)
    .sort((left, right) => right.length - left.length)
  if (!initials.length) return description

  const escapedInitials = initials.map(initial => initial.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))
  const matcher = new RegExp(`(^|[^\\p{L}\\p{N}])(${escapedInitials.join('|')})(?=$|[^\\p{L}\\p{N}])`, 'gu')
  return description.replace(matcher, (_match, prefix: string, initial: string) => `${prefix}${userNames[initial]}`)
}
